export const JFROG_TOKEN_DURATIONS = {
  short: { days: 90, label: "90 days (short)" },
  long: { days: 365, label: "1 year (long)" },
} as const;

export type JFrogTokenDuration = keyof typeof JFROG_TOKEN_DURATIONS;

export const DEFAULT_JFROG_TOKEN_DURATION: JFrogTokenDuration = "long";

export function getJFrogTokenExpiryDays(duration: JFrogTokenDuration): number {
  return JFROG_TOKEN_DURATIONS[duration].days;
}
